import { ILookup, ILookupItem } from "@ngt/opms";
import { useMemo } from "react";
import { SWRConfiguration } from "swr";
import useConsentVersions from "../data/useConsentVersion";


export const PICF_VERSION_OTHER_ID = 0;

const useConsentVersionLookup = (propertyName: string, institutionCode?: string, picfTypeName?: string, hideOther?: boolean, configuration?: SWRConfiguration) => {
    const output = useConsentVersions(institutionCode, picfTypeName, configuration);

    const modifiedOutput = useMemo(() => {
        const lookupItems: ILookupItem[] = output.data ?
            Object.keys(output.data).map((key) => {
                return {
                    id: output.data![key as any as number].picfId as any,
                    value: output.data![key as any as number].version ?? ''
                }
            }) :
            [];

        if (!hideOther) {
            lookupItems.push({
                id: PICF_VERSION_OTHER_ID as any,
                value: 'Other'
            });
        }

        const lookups: ILookup = {
            propertyName: propertyName,
            items: lookupItems
        };

        return {
            ...output,
            data: lookups
        }
    }, [output, propertyName, hideOther])

    return modifiedOutput;
};

export default useConsentVersionLookup;
